/**
 *  Define a token for the IApiService interface
 */
export const IApiServiceToken = 'ApiServiceToken';
